import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-asistenciaindividual',
  templateUrl: './asistenciaindividual.component.html',
  styleUrls: ['./asistenciaindividual.component.css']
})
export class AsistenciaindividualComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
